import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader } from '../helpers';
import { postApi } from '../helpers/http';

export const requestVersions = date => ({
  type: ActionTypes.REQUEST_VERSION,
  date
})

export const requestVersionsOs = date => ({
  type: ActionTypes.REQUEST_VERSION_OS,
  date
})

export const requestVersionsApi = date => ({
  type: ActionTypes.REQUEST_VERSION_API,
  date
})

export const receiveVersions = (params, json) => ({
  type: ActionTypes.RECEIVE_VERSION,
  date: params.date,
  items: json.data,
  receivedAt: Date.now()
})

export const receiveVersionsOs = (params, json) => ({
  type: ActionTypes.RECEIVE_VERSION_OS,
  date: params.date,
  version_info: json.data.version_info,
  receivedAt: Date.now()
})

export const receiveVersionsApi = (params, json) => ({
  type: ActionTypes.RECEIVE_VERSION_API,
  api_version_info: json.data.version,
  receivedAt: Date.now()
})

const doFetchVersions = params => async dispatch => {
  dispatch(requestVersions(params))
  const data = {
    "process_type": "getHpa27VersionList",
    // "os_info": ""
  };

  try {
    const json = await postApi(data);
    dispatch(receiveVersions(params, json))
  } catch (error) {
    console.error('Error:', error);
  };

}

const doFetchVersionsOs = params => async dispatch => {
  dispatch(requestVersionsOs(params))

  const data = {
    "process_type": "getHpa27VersionInfo",
    "os_info": params.os_info
  };

  try {
    const json = await postApi(data);
    dispatch(receiveVersionsOs(params, json))
  } catch (error) {
    console.error('Error:', error);
  };

}

const doFetchVersionsApi = params => async dispatch => {
  dispatch(requestVersionsApi(params))

  const data = {
    "process_type": "getSystemInfo"
  };

  try {
    const json = await postApi(data);
    dispatch(receiveVersionsApi(params, json))
  } catch (error) {
    console.error('Error:', error);
  };

}

export const fetchVersions = params => (dispatch, getState) => {
  return dispatch(doFetchVersions(params))
}

export const fetchVersionsOs = params => (dispatch, getState) => {
  return dispatch(doFetchVersionsOs(params))
}

export const fetchVersionsApi = params => (dispatch, getState) => {
  return dispatch(doFetchVersionsApi(params))
}
